import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTankFloatingRoofBoot = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 80,
	viewBox: "0 0 100.0 80.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 0.0 70.0 L 70.0 70.0 L 80.0 80.0 L 100.0 80.0 L 100.0 0.0 L 95.0 0.0 L 95.0 5.0 L 5.0 5.0 L 5.0 0.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 5.0 0.0 L 5.0 5.0 L 95.0 5.0 L 95.0 0.0 M 0.0 0.0 L 0.0 70.0 L 70.0 70.0 L 80.0 80.0 L 100.0 80.0 L 100.0 0.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgTankFloatingRoofBoot;
